<template>
  <div class="vue-mobile-header-wrap">
    <div class="row-item logo">
      <div class="logo-container-wrap">
        <div class="logo-container">
          <div class="text-container">
            <div class="left-column">
            <h1 class="title">VT Outages</h1>
          </div>
          <div class="right-column">
            <div class="right-row">
              <h2 class="title sub-title">Vermont's Power</h2>
            </div>
            <div class="right-row">
              <h2 class="title sub-title">Outage Resource</h2>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row-item outage">
      <div class="outage-summary-container-wrap">
        <div class="outage-summary-container">
          <span class="outage-summary">
            <span class="key">{{totalEvents}}</span><span class="val">Events</span>
          </span>
          <span class="outage-summary">
            <span class="key">{{totalCustomers}}</span><span class="val">Customers Affected</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: {
    totalEvents: Number,
    totalCustomers: Number
  },
  methods: {
    reloadPage() {
      window.location.reload();
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.vue-mobile-header-wrap{
  background-color: $navyBackgroundTrans95;
  display: flex;
  flex-direction: column;
  height: 80px;
  
  .row-item{
    .logo-container-wrap{
      height: 50px;
      background-color: #fff;

      .logo-container{
        width: 300px;
        padding: 10px;
        padding: 0;
        margin: 0;

        .text-container {
            display: flex;
            height: 50px;

            .title{
                margin: 10px 0 0 10px;
                color: $navyBackgroundTrans85;
                font-weight: 1000;
                font-size: 25px;
                text-transform: uppercase;
            }

            .left-column {
              flex: 0 0 165px;
            }

          .right-column {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 11px 0 0 0;
            margin: 0;

            .right-row {
              flex: 1;
              max-height: 12px;
              display: flex;
              align-items: center;

              .sub-title {
                font-size: 10px;
                margin: 0;
              }
            }
          }
        }

        &.isDarkMode{
          background-color: $navyBackgroundTrans85;
          border-bottom: 1px solid $greyTextTrans25;

          .title{
            color: $whiteTextTrans85;
          }
          .sub-title{
            color: $whiteTextTrans85;
          }
        }

        &:hover{
          cursor: pointer;
        }
      }
    }

    .outage-summary-container-wrap{
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        height: 30px;
        align-self: stretch;

      .outage-summary-container{
        .outage-summary{
          &:first-child{
            margin-right: 10px;
          }

          .key{
            margin-right: 10px;
            font-weight: bold;
          }

          .val{
            font-style: italic;
          }
        }
      }
    }
  }
}

@media (orientation: landscape) {
  .vue-mobile-header-wrap{
    display: block;
    height: 50px;

    .row-item{
      display: inline-block;
      vertical-align: bottom;
      width: 50%;

      .logo-container-wrap{
        .logo-container{
          width: 300px;
          margin-left: 20px;
        }
      }

      &.outage{
        .outage-summary-container-wrap{
          display: block;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
